/** Case- and width-insensitive fold: NFKC folds full-width digits and letters
 *  onto their half-width forms, then lowercase folds the case — so 'Ｄ１６',
 *  'd16' and 'D16' are one and the same name. The one identity rule for
 *  material and unit names across the app. Server-safe: the backend
 *  (`core/shared/text.ts`), the clients (`client/utils/text.ts`) and the
 *  shared unit vocabulary all re-export or import this one definition. */
export const fold = (text: string): string => text.normalize('NFKC').toLowerCase();
